import React from "react"
import {useLocal} from "../../AppContext"
import style from "./SelectNote.css"

export const SelectNote = () => {
    const local = useLocal()

    return <div className={style.sortNote}>{local.__("Mehrfachauswahl möglich")}</div>
}
